module.exports = __webpack_public_path__ + "static/media/TP.98defe5d.png";